export default __webpack_public_path__ + "static/media/smarter-gallery.23abfad4.webp";